<template>
  <div class="monthly-plan">
    <div class="wrap-inside-plan">
      <div class="header">
        <h3 class="mb-0">月額プラン情報確認</h3>
      </div>
      <div class="text-center">
        <h3 class="font-weight-bold mb-2">See Our Packages</h3>
      </div>
      <div class="text-center">
        <p class="mb-3">
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
          <br/>invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.
        </p>
      </div>
      <div class="wrap-content d-flex justify-content-between">
        <div class="plan-item">
          <div class="wrap-plan-item first-plan">
            <div class="text-center font-weight-bold plan-price">¥0/月</div>
            <div class="text-center plan-name">Plan A</div>
          </div>
          <div class="text-center seller-fee">出品者手数料</div>
          <div class="wrap-row-content">
            <div class="title-content-fee">入札金額</div>
            <div class="title-content-fee">料率</div>
          </div>
          <div class="wrap-row-content">
            <div class="title-content-fee">(出子開始価格と落札価格差分)</div>
            <div class="title-content-fee">(差分に対して)</div>
          </div>
          <hr class="hr-item my-2"/>
          <div class="wrap-row-content">
            <div>¥500,000以下</div>
            <div class="first-fee">50%</div>
          </div>
          <hr class="hr-item my-2"/>
          <div class="wrap-row-content">
            <div>¥550,000 〜 ¥2,000,000</div>
            <div class="first-fee">30%</div>
          </div>
          <hr class="hr-item my-2"/>
          <div class="wrap-row-content mb-2">
            <div>¥2,050,000以上</div>
            <div class="first-fee">20%</div>
          </div>
          <div class="wrap-end-plan">
            <div class="text-center font-weight-bold mb-2">落札者手数料</div>
            <div class="text-rate font-weight-bold">料率</div>
            <div class="text-rate font-weight-bold">(落札金額に対して)</div>
            <hr class="hr-item my-2"/>
            <div class="text-rate first-fee">1.5%</div>
          </div>
          <div class="cs-button-regis" @click="handleModal">
            <label class="first-plan-btn">このプランに変更する</label>
          </div>
        </div>
        <div class="plan-item">
          <div class="wrap-plan-item second-plan">
            <div class="text-center font-weight-bold plan-price">¥40,000/月</div>
            <div class="text-center plan-name">Plan B</div>
          </div>
          <div class="text-center seller-fee">出品者手数料</div>
          <div class="wrap-row-content">
            <div class="title-content-fee">入札金額</div>
            <div class="title-content-fee">料率</div>
          </div>
          <div class="wrap-row-content">
            <div class="title-content-fee">(出子開始価格と落札価格差分)</div>
            <div class="title-content-fee">(差分に対して)</div>
          </div>
          <hr class="hr-item my-2"/>
          <div class="wrap-row-content">
            <div>¥500,000以下</div>
            <div class="second-fee">30%</div>
          </div>
          <hr class="hr-item my-2"/>
          <div class="wrap-row-content">
            <div>¥550,000 〜 ¥2,000,000</div>
            <div class="second-fee">20%</div>
          </div>
          <hr class="hr-item my-2"/>
          <div class="wrap-row-content mb-2">
            <div>¥2,050,000以上</div>
            <div class="second-fee">15%</div>
          </div>
          <div class="wrap-end-plan">
            <div class="text-center font-weight-bold mb-2">落札者手数料</div>
            <div class="text-rate font-weight-bold">料率</div>
            <div class="text-rate font-weight-bold">(落札金額に対して)</div>
            <hr class="hr-item my-2"/>
            <div class="text-rate second-fee">1.0%</div>
          </div>
          <div class="cs-button-regis" @click="handleModal">
            <label class="second-plan-btn">使用 中</label>
          </div>
        </div>
        <div class="plan-item">
          <div class="wrap-plan-item third-plan">
            <div class="text-center font-weight-bold plan-price">¥100,000/月</div>
            <div class="text-center plan-name">Plan C</div>
          </div>
          <div class="text-center seller-fee">出品者手数料</div>
          <div class="wrap-row-content">
            <div class="title-content-fee">入札金額</div>
            <div class="title-content-fee">料率</div>
          </div>
          <div class="wrap-row-content">
            <div class="title-content-fee">(出子開始価格と落札価格差分)</div>
            <div class="title-content-fee">(差分に対して)</div>
          </div>
          <hr class="hr-item my-2"/>
          <div class="wrap-row-content">
            <div>¥500,000以下</div>
            <div class="third-fee">10%</div>
          </div>
          <hr class="hr-item my-2"/>
          <div class="wrap-row-content">
            <div>¥550,000 〜 ¥2,000,000</div>
            <div class="third-fee">8%</div>
          </div>
          <hr class="hr-item my-2"/>
          <div class="wrap-row-content mb-2">
            <div>¥2,050,000以上</div>
            <div class="third-fee">5%</div>
          </div>
          <div class="wrap-end-plan">
            <div class="text-center font-weight-bold mb-2">落札者手数料</div>
            <div class="text-rate font-weight-bold">料率</div>
            <div class="text-rate font-weight-bold">(落札金額に対して)</div>
            <hr class="hr-item my-2"/>
            <div class="text-rate third-fee">0.7%</div>
          </div>
          <div class="cs-button-regis" @click="handleModal">
            <label class="third-plan-btn">このプランに変更する</label>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center wrap-outside-btn">
      <label class="mb-0 outside-btn">簡易シミュレート</label>
    </div>
    <a-modal
      class="m-monthly-plan-container"
      wrapClassName="m-monthly-plan"
      :visible="visible"
      title="月額プランの変更"
      centered
      :maskClosable="false"
      :footer="null"
      @cancel="handleModal"
    >
      <div class="m-plan-content">
        <div class="font-weight-bold mb-3 title-plan">{Plan A}に変更してもよろしいでしょうか？</div>
        <div class="desc-plan mb-3 p-3">
          <p>
            ■変更時のご注意事項 <br><br>
            月額プランのサービス期間は、プラン変更日から1か月となります。<br>
            フリープランから有料プランへ変更を行った場合、即時プランが変更されます。<br><br>
            有料プランから異なる有料プランへ変更を行った場合、<br>
            元の有料プランのサービス期間終了後にプランが変更となります。<br><br>
            プランはお客様側で変更を行わない限り、自動更新となります。<br>
          </p>
        </div>
        <div class="plan-btn-group">
          <div class="cs-btn-plan cs-btn-change" @click="handleModal">
            <label>決定する</label>
          </div>
          <div class="cs-btn-plan cs-btn-cancel" @click="handleModal">
            <label>キャンセル</label>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'MonthlyPlan',
  components: {},
  data() {
    return {
      visible: false,
    };
  },
  created() {
    window.scrollTo(0, 0);
  },
  methods: {
    handleModal() {
      this.visible = !this.visible;
    },
  },
};
</script>
